import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "dd-item-container" }
const _hoisted_3 = { class: "dd-item-icon" }
const _hoisted_4 = { class: "dd-item-text" }
const _hoisted_5 = { class: "dd-item-container" }
const _hoisted_6 = { class: "dd-item-icon" }
const _hoisted_7 = { class: "dd-item-text" }

import Icon from "@common/components/Icon.vue";
import ProgressModal from "@common/components/ProgressModal.vue";
import { useGlobalParameters } from "@common/composable/useRootStore";
import { ActivityCriteria } from "@medapro-types/common/activity/activity";
import { ActivityAction, ActivityObject, ActivityProcess, ActivitySeverity, ActivityStatus } from "@medapro-types/common/activity/activity-enums";
import { ProgressHandler } from "@medapro-types/common/components/ProgressHandling";
import { TranslationFileType, TranslationGroupType } from "@medapro-types/TranslationManager/translationManager";
import activityApi from "@services/activity";
import applications from "@services/applications";
import { useTranslationManagerActions } from "@TranslationManager/composables/useTranslationManagerStore";
import { computed, reactive } from "vue";
import { useI18n } from "vue-i18n";

//#region General
type ViewModel = {
  progressHandler: ProgressHandler;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportButton',
  props: {
    id: {},
    translationProjectId: {},
    translationGroup: {},
    translationProjectName: {},
    dataChangeAllowedCheck: {},
    disabled: { type: Boolean, default: false },
    iconOnly: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props;


//#endregion

//#region Store
const { exportTranslations } = useTranslationManagerActions();
const { globalParameters } = useGlobalParameters();
const { t: $t } = useI18n();
//#endregion

//#region ViewModel
const vm = reactive<ViewModel>({
  progressHandler: ProgressHandler.createIndeterminate({ id: `${props.id}-button-progress-modal`, isCancellable: true })
});
//#endregion

//#region Export
const exportCancelled = () => {
  vm.progressHandler.cancel(`${$t("translationManager.cancellingExport")}...`);
};

const beginExport = async (fileType: TranslationFileType) => {
  if (!canExport.value && !props.dataChangeAllowedCheck()) {
    return;
  }

  const result = await exportTranslations({
    fileType: fileType,
    translationGroup: props.translationGroup,
    progressHandler: vm.progressHandler
  });

  if (result) {
    await createActivityEntry(result.filename);
  }
};

const createActivityEntry = async (filename: string) => {
  try {
    if (globalParameters.value.IsActivityFeedEnabled) {
      const activityCriterias: ActivityCriteria[] = [
        {
          severity: ActivitySeverity.Information,
          process: ActivityProcess.Export,
          objectType: ActivityObject.TranslationProject,
          status: ActivityStatus.Successful,
          action: ActivityAction.Completed,
          descriptionValues: [filename],
          descriptionKey: "TranslationProjectExported",
          objectValue: props.translationProjectName,
          applicationId: applications.Modules.TranslationManager.Id
        }
      ];

      await activityApi.createActivity(activityCriterias);
    }
  } catch (error) {
    console.error("Activity insertion for translation project export failed with error : ", error);
  }
};

const canExport = computed(() => {
  return props.translationProjectId && !props.disabled;
});

const buttonClasses = computed(() => {
  return `mono ${props.iconOnly ? "btn-icon" : "btn-with-icon"}`;
});
//#endregion

return (_ctx: any,_cache: any) => {
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item")!
  const _component_b_dropdown = _resolveComponent("b-dropdown")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createBlock(_component_b_dropdown, {
      split: "",
      "split-class": buttonClasses.value,
      "toggle-class": buttonClasses.value,
      class: _normalizeClass(["split-button", { 'disabled-split-button': !canExport.value }]),
      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (beginExport(_unref(TranslationFileType).Excel)), ["prevent"])),
      disabled: !canExport.value
    }, {
      "button-content": _withCtx(() => [
        _createVNode(Icon, { icon: "Export" }),
        (!props.iconOnly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref($t)(props.translationGroup ? "translationManager.exportTable" : "translationManager.exportProject")), 1))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_b_dropdown_item, {
          "link-class": "icon-item",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (beginExport(_unref(TranslationFileType).Excel)), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, [
                _createVNode(Icon, { icon: "FileExcel" })
              ]),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_unref($t)("translationManager.exportExcel")), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_b_dropdown_item, {
          "link-class": "icon-item",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (beginExport(_unref(TranslationFileType).XLIFF)), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, [
                _createVNode(Icon, { icon: "Export" })
              ]),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref($t)("translationManager.exportXliff")), 1)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["split-class", "toggle-class", "class", "disabled"])), [
      [_directive_tooltip, _unref($t)(props.translationGroup ? 'translationManager.exportTable' : 'translationManager.exportProject')]
    ]),
    _createVNode(ProgressModal, {
      progress: vm.progressHandler.progress,
      onCancel: exportCancelled,
      "min-open-time": 1000,
      "auto-close": true
    }, null, 8, ["progress"])
  ], 64))
}
}

})